export const pythonHttp = `from web3 import Web3
          
def test_block_number(self):
    url = '__url__'  # url string
    
    web3 = Web3(Web3.HTTPProvider(url))
    print(web3.eth.block_number)`;
